/* eslint-disable react-hooks/exhaustive-deps */
import ExchangeOnlineModal from './exchangeOnlineModal';
import ExchangeInlineModal from './exchangeInlineModal';
import GmailModal from './gmailModal';
import { ProvisionStatus } from '@Types/provision';
import GmailInlineModal from './gmailInlineModal';
import { useEffect, useState } from 'react';
import { ProvisionApi } from '@Apis';
import { usePermissionStore } from '@Models/usePermissionModel';
import { PermissionNameEnum } from '@Types/permissions';
import TeamsChatModal from './teamsChatModal';
import CommonModal from './CommonModal';
import GoogleDriveModal from './googleDriveModal';
import MipModal from './mipModal';
import { useLicenseStore } from '@Models/useLicenseModel';
import SalesForceModal from './salesforceModal';
import TeamsGraphModal from '@Dashboard/ProvisionModal/teamsGraphModal';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';
import { Service } from '@Types/app';
import SharePointGraphModal from '@Dashboard/ProvisionModal/sharePointGraphModal';
import OneDriveGraphModal from '@Dashboard/ProvisionModal/oneDriveGraphModal';

const ProvisionModal = ({
  orgId,
  modalState,
  isOpen,
  onClose,
}: {
  orgId: string;
  modalState: {
    serviceType: Service;
  };
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { serviceType } = modalState;
  const { widthEditablePermission } = usePermissionStore();
  const administratorEditPermission = widthEditablePermission(
    PermissionNameEnum.administrator
  );
  const { hasEmailAddOnLicense } = useLicenseStore();
  const [provisionStatus, setProvisionStatus] =
    useState<ProvisionStatus | null>(null);
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();

  useEffect(() => {
    if (administratorEditPermission) {
      ProvisionApi.apiGetProvisionStatus(serviceType, orgId)
        .then((res) => {
          setProvisionStatus(res.data);
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }, [modalState]);

  if (orgId === 'all' || !provisionStatus || !administratorEditPermission) {
    return <></>;
  }

  if (
    [Service.GmailInline, Service.ExchangeInline].includes(serviceType) &&
    !hasEmailAddOnLicense
  ) {
    console.warn(`no addon license, can not provision ${serviceType}`);
    return <></>;
  }

  const state = {
    provisionStatus,
    orgId,
    isOpen,
    onClose,
  };
  if (serviceType === Service.Exchange) {
    return <ExchangeOnlineModal {...state} />;
  }
  if (serviceType === Service.ExchangeInline) {
    return <ExchangeInlineModal {...state} />;
  }
  if (serviceType === Service.Gmail) {
    return <GmailModal {...state} />;
  }
  if (serviceType === Service.GmailInline) {
    return <GmailInlineModal {...state} />;
  }

  if (
    serviceType === Service.Teams ||
    serviceType === Service.OneDrive ||
    serviceType === Service.SharePoint ||
    serviceType === Service.Box ||
    serviceType === Service.Dropbox
  ) {
    if (
      serviceType === Service.Teams &&
      selectedOrgGlobalSetting.newTeamsMultiAppsProvision
    ) {
      return <TeamsGraphModal {...state} />;
    }

    if (
      serviceType === Service.OneDrive &&
      selectedOrgGlobalSetting.newOnedriveMultiAppsProvision
    ) {
      return <OneDriveGraphModal {...state} />;
    }

    if (
      serviceType === Service.SharePoint &&
      selectedOrgGlobalSetting.newSharepointMultiAppsProvision
    ) {
      return <SharePointGraphModal {...state} />;
    }

    return <CommonModal {...state} service={serviceType} />;
  }

  if (serviceType === Service.TeamsChat) {
    return <TeamsChatModal {...state} />;
  }

  if (serviceType === Service.GoogleDrive) {
    return <GoogleDriveModal {...state} />;
  }

  if (
    serviceType === Service.IdentityProtection ||
    serviceType === Service.Mip
  ) {
    return <MipModal service={serviceType} {...state} />;
  }

  if (
    serviceType === Service.SalesforceProduction ||
    serviceType === Service.SalesforceSandbox
  ) {
    return <SalesForceModal service={serviceType} {...state} />;
  }

  return <></>;
  // return (
  //   <Modal isOpen={isOpen} isClosable onClose={onClose} size="lg">
  //     <ModalOverlay />
  //     <ModalContent>
  //       <ModalHeader>Provision Modal</ModalHeader>
  //       <ModalBody>
  //         <Text>orgId: {orgId}</Text>
  //         <Text>serviceType: {serviceType}</Text>
  //       </ModalBody>
  //       <ModalFooter>
  //         <Button minWidth="20x" onClick={onClose}>
  //           Close
  //         </Button>
  //       </ModalFooter>
  //     </ModalContent>
  //   </Modal>
  // );
};
export default ProvisionModal;
